import React from 'react';
import { withTranslation } from 'react-i18next';

var bgimg1 = require('../../images/background/about2.png');

class About2 extends React.Component {
    render() {
        const { t } = this.props;
        return (
            <div className="about-copra mobile-page-padding">
                <div className="container">
                    <div className="about-copra-grid">
                        {/* Imagen */}
                        <figure className="about-copra-figure">
                            <div className="ac-img" style={{ backgroundImage: 'url(' + bgimg1 + ')' }} />
                        </figure>

                        {/* Contenido */}
                        <div className="about-copra-content">
                            <p className="about-copra-eyebrow">{t('pages.about.about2.eyebrow')}</p>
                            <h2 className="about-copra-title">SoltArc</h2>
                            <div className="about-copra-rule" />
                            <p className="about-copra-lead">{t('pages.about.about2.paragraph1')}</p>
                            <div className="about-copra-body">
                                <p>{t('pages.about.about2.paragraph2')}</p>
                                <p>{t('pages.about.about2.paragraph3')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default withTranslation()(About2);
